import React, {Dispatch, SetStateAction, PropsWithChildren, InputHTMLAttributes} from "react"
import classNames from "classnames"
import Dropdown from "../Address/Dropdown"
import Textfield from "../Address/Textfield"

interface SwitchProps extends InputHTMLAttributes<HTMLInputElement> {
	checked?: boolean
	onChange: Dispatch<SetStateAction<any>>
}

function Switch({name, checked, onChange, ...inputProps}: SwitchProps) {
	return (
		<label className="switch">
			<input name={name} type="checkbox" checked={checked} onChange={onChange} {...inputProps} />
			<span className="slider round"></span>
		</label>
	)
}

interface ToggleSwitchProps extends InputHTMLAttributes<HTMLInputElement> {
	text?: string | React.ReactNode
	className?: string
	checked?: boolean
	onChange: Dispatch<SetStateAction<any>>
	onBlur?: Dispatch<SetStateAction<any>>
	subName?: string
	subLabel?: string
	subValue?: string | number
	inputType?: string
	alignRight?: boolean
}

export default function ToggleSwitch({
	name,
	subName,
	text,
	subLabel,
	className,
	checked,
	subValue,
	onChange,
	inputType,
	children,
	alignRight,
	...inputProps
}: PropsWithChildren<ToggleSwitchProps>) {
	return (
		<div className="toggle-switch">
			<div className={classNames("toggle", className, alignRight && "is-flex-direction-row-reverse")}>
				<Switch name={name} checked={checked} onChange={onChange} {...inputProps} />
				<span className="text">{text}</span>
			</div>
			{subName !== undefined && subLabel !== undefined && subValue !== undefined && (
				<div className="form-row four">
					{inputType === "select" ? (
						<Dropdown
							name={subName}
							label={subLabel}
							value={subValue}
							onChange={onChange}
							disabled={!checked || !!inputProps.disabled}
						>
							{children}
						</Dropdown>
					) : inputType === "input" && inputProps.onBlur !== undefined ? (
						<Textfield
							name={subName}
							label={subLabel}
							value={subValue}
							onBlur={inputProps.onBlur}
							onChange={onChange}
							disabled={!checked || !!inputProps.disabled}
						/>
					) : null}
				</div>
			)}
		</div>
	)
}
